import { render, staticRenderFns } from "./HealthManagement.vue?vue&type=template&id=21f79b66&scoped=true"
import script from "./HealthManagement.vue?vue&type=script&lang=js"
export * from "./HealthManagement.vue?vue&type=script&lang=js"
import style0 from "./HealthManagement.vue?vue&type=style&index=0&id=21f79b66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f79b66",
  null
  
)

export default component.exports